module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedLight.8f8c505.eot";